var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-list-group',{staticClass:"photo_book_page_list_group"},_vm._l((_vm.images),function(image){return _c('b-list-group',{key:image.id,attrs:{"flush":""}},[_c('b-list-group-item',{staticClass:"photo_book_image",attrs:{"href":"#"}},[_c('photo-book-image',{attrs:{"image":image}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }